import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

import { AutoUnsubscribe, getSupportEmail } from 'helpers';
import { SignupErrorType } from '../../types';

@Component({
    selector: 'fc-signup-error',
    templateUrl: './signup-error.component.html',
    styleUrls: ['./signup-error.component.less'],
    standalone: false
})
@AutoUnsubscribe
export class SignupErrorComponent implements OnInit {
    @Input() errorType?: SignupErrorType;
    @Input() actionButtonLabel?: string;
    @Input() redirectToLogin?: boolean = false;
    @Output() actionButtonClicked = new EventEmitter<void>();

    supportEmail = getSupportEmail();
    text: {
        header: string;
        description: string;
    };

    private readonly errorMessageMap = {
        [SignupErrorType.UserAlreadyExistsError]: 'SIGNUP.ERROR.EXISTS',
        [SignupErrorType.ValidationError]: 'SIGNUP.ERROR.PARAMETERS',
        [SignupErrorType.SignupRequestAlreadyExistsError]: 'SIGNUP.ERROR.SIGNUP_REQUEST_EXISTS',
        [SignupErrorType.SignupRequestNotFoundError]: 'SIGNUP.FORM.REQUEST_NOT_FOUND.DESCRIPTION',
        [SignupErrorType.InvitationAlreadyExistsError]: 'SIGNUP.ERROR.INVITATION_PENDING',
        [SignupErrorType.InvitationUsedError]: 'SIGNUP.ERROR.INVITATION.USED',
        [SignupErrorType.InvitationExpiredError]: 'SIGNUP.ERROR.INVITATION.EXPIRED',
        [SignupErrorType.InvalidInvitationCodeError]: 'SIGNUP.ERROR.INVITATION.CODE',
        [SignupErrorType.InvalidReferralIdError]: 'SIGNUP.REFERRAL_ERROR_TITLE',
        [SignupErrorType.UnknownError]: 'ERROR_UNKNOWN'
    };

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        if (
            !this.errorType ||
            !this.errorMessageMap[this.errorType] ||
            this.errorType === SignupErrorType.UnknownError
        ) {
            this.text = {
                header: this.errorMessageMap[SignupErrorType.UnknownError],
                description: 'ERROR_UNKNOWN_DESCRIPTION'
            };
        } else {
            this.text = {
                header: 'ERROR',
                description: this.errorMessageMap[this.errorType]
            };
        }
    }

    onActionButtonClick() {
        this.actionButtonClicked.emit();
    }

    goToLogin() {
        this.authService.loginWithRedirect();
        return;
    }
}
